import React from 'react';

/**
 * 🎁 Treasure Hunt Mode Button - Gift Emoji Style
 * 이모지 기반 선물 상자 버튼
 */
const TreasureHuntButton = ({ onClick, isActive, size = 48, ariaLabel }) => {
  const isSmall = size < 40;
  const emojiSize = Math.floor(size * 0.66);
  const sparkleSize1 = Math.floor(size * 0.25);
  const sparkleSize2 = Math.floor(size * 0.2);
  const sparkleSize3 = Math.floor(size * 0.16);

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      style={{
        position: 'relative',
        width: `${size}px`,
        height: `${size}px`,
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        padding: 0,
        animation: isActive ? 'none' : 'giftFloat 1.5s ease-in-out infinite',
        transform: 'translateZ(0)',
        willChange: 'transform',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      onMouseEnter={(e) => {
        if (!isActive) {
          e.currentTarget.style.transform = 'scale(1.15)';
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      <style>{`
        @keyframes giftFloat {
          0%, 100% { 
            transform: translateY(0) scale(1); 
          }
          50% { 
            transform: translateY(-2px) scale(1.05); 
          }
        }
        
        @keyframes sparkle {
          0%, 100% { 
            opacity: 0;
            transform: scale(0.5);
          }
          50% { 
            opacity: 1;
            transform: scale(1.2);
          }
        }
        
        @keyframes glow {
          0%, 100% { 
            box-shadow: 0 0 ${size / 5}px rgba(168, 85, 247, 0.4);
          }
          50% { 
            box-shadow: 0 0 ${size / 2.5}px rgba(168, 85, 247, 0.8);
          }
        }
      `}</style>

      {/* Glow Background */}
      {!isActive && (
        <div style={{
          position: 'absolute',
          width: '80%',
          height: '80%',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(168, 85, 247, 0.4) 0%, transparent 70%)',
          animation: 'glow 2s ease-in-out infinite'
        }} />
      )}

      {/* Container */}
      <div style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {/* Sparkles */}
        {!isActive && (
          <>
            <div style={{
              position: 'absolute',
              top: '0px',
              right: '2px',
              fontSize: `${sparkleSize1}px`,
              animation: 'sparkle 1.5s ease-in-out infinite'
            }}>✨</div>
            <div style={{
              position: 'absolute',
              bottom: '0px',
              left: '0px',
              fontSize: `${sparkleSize2}px`,
              animation: 'sparkle 1.5s ease-in-out infinite 0.5s'
            }}>✨</div>
            {!isSmall && (
              <div style={{
                position: 'absolute',
                top: '4px',
                left: '-2px',
                fontSize: `${sparkleSize3}px`,
                animation: 'sparkle 1.5s ease-in-out infinite 1s'
              }}>⭐</div>
            )}
          </>
        )}

        {/* Main Gift Emoji */}
        <div style={{
          fontSize: `${emojiSize}px`,
          lineHeight: `${emojiSize}px`,
          filter: isActive
            ? 'drop-shadow(0 2px 4px rgba(239, 68, 68, 0.4))'
            : 'drop-shadow(0 4px 8px rgba(168, 85, 247, 0.4))',
          transition: 'filter 0.3s ease'
        }}>
          🎁
        </div>

        {/* Active State Indicator */}
        {isActive && (
          <div style={{
            position: 'absolute',
            width: '80%',
            height: '80%',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(239, 68, 68, 0.3) 0%, transparent 70%)',
            animation: 'glow 1.5s ease-in-out infinite'
          }} />
        )}
      </div>
    </button>
  );
};

export default TreasureHuntButton;
